import { PATHWAY } from "@/constants/testIds";
import { PRODUCT } from "@/lib/pathwayData";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* Background texture, very low opacity */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1533135091724-62cc5402aa20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxkYXJrJTIwYWJzdHJhY3QlMjBnZW9tZXRyaWMlMjBsaW5lcyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODI3MzQ4MjB8MA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "screen",
        }}
        aria-hidden="true"
      />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-white/12" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-6 pb-24 pt-20 md:grid-cols-[1.5fr_1fr] md:gap-16 md:px-12 md:pb-32 md:pt-28">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-amber-600">
            {PRODUCT.sponsorPositioningLine}
          </div>

          <h1
            data-testid={PATHWAY.heroTitle}
            className="mt-8 font-serif text-4xl leading-[1.05] tracking-tight text-neutral-50 sm:text-5xl lg:text-6xl"
          >
            From emerging risk to{" "}
            <span className="italic text-amber-600">governed</span> insurance
            pathway.
          </h1>

          <p
            data-testid={PATHWAY.heroSubtitle}
            className="mt-8 max-w-2xl text-[17px] leading-relaxed text-neutral-300"
          >
            {PRODUCT.heroSubtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#intake"
              data-testid={PATHWAY.heroSponsorCta}
              className="border border-amber-700 bg-amber-700 px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-white transition-colors hover:bg-amber-600"
            >
              Sponsor the pathway
            </a>
            <a
              href="#journey"
              data-testid={PATHWAY.heroExploreCta}
              className="border hairline px-5 py-3 font-mono text-xs uppercase tracking-[0.22em] text-neutral-200 transition-colors hover:border-neutral-500"
            >
              Explore the playground →
            </a>
          </div>
        </div>

        <aside className="border-l hairline pl-8 md:pl-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">
            Core proposition
          </div>
          <p className="mt-4 font-serif text-xl italic leading-snug text-neutral-200">
            “{PRODUCT.coreLine}”
          </p>
          <div className="mt-10 border-t hairline pt-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">
              Sponsor positioning
            </div>
            <p className="mt-3 text-sm leading-relaxed text-neutral-300">
              {PRODUCT.sponsorThoughtLine}
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}
